module.exports = __webpack_public_path__ + "img/status_2.28552f1f.png";